import { Check, Save } from "@mui/icons-material";
import { Fab, Box, CircularProgress, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import { useState, useEffect } from "react";
import { green } from "@mui/material/colors";
import axios from "axios";

const UsersActions = ({ params, rowId, setRowId }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const handleSubmit = async () => {
    setLoading(true);

    const { access_level, password, id } = params.row;

    const updatedData = {
      access_level,
      password,
    };

    try {
      setTimeout(async () => {
        const response = await axios.post(
          process.env.REACT_APP_UPDATE_USER + `/${id}`,
          updatedData
        );

        if (response) {
          setSuccess(true);
          setRowId(null);
        }
        setLoading(false);
      }, 1500);
    } catch (error) {
      console.error("Error updating user:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (rowId === params.id && success) setSuccess(false);
  }, [rowId, params.id]);

  return (
    <Box
      sx={{
        m: 1,
        position: "relative",
      }}
    >
      {success ? (
        <Fab
          color="primary"
          sx={{
            width: 40,
            height: 40,
            bgcolor: green[600],
            "&:hover": { bgcolor: colors.greenAccent[700] },
          }}
        >
          <Check />
        </Fab>
      ) : (
        <Fab
          color="primary"
          sx={{ width: 40, height: 40 }}
          disabled={params.id !== rowId || loading}
          onClick={handleSubmit}
        >
          <Save />
        </Fab>
      )}
      {loading && (
        <CircularProgress
          size={52}
          sx={{
            color: green[500],
            position: "absolute",
            top: -6,
            left: -6,
            zIndex: 1,
          }}
        />
      )}
    </Box>
  );
};

export default UsersActions;
